import { GenericFilter } from "@repo/ui";
import type {
  FilterConfig,
  SelectOption,
  DataTableSetColumnFilter,
  DataTableFilters,
} from "@repo/ui";

type PermissionFilterKey = "roles" | "customers" | "brands";

type Props<T extends { [K in PermissionFilterKey]: T[K] }> = {
  setColumnFilter: DataTableSetColumnFilter<T>;
  filters: DataTableFilters<T>;
  roleOptions: SelectOption<string>[];
  customerOptions: SelectOption<number>[];
  brandOptions: SelectOption<number>[];
};

export const PermissionFilters = <T extends { [K in PermissionFilterKey]: T[K] }>({
  setColumnFilter,
  filters,
  roleOptions,
  customerOptions,
  brandOptions,
}: Props<T>) => {
  const filterConfigs: FilterConfig<T, PermissionFilterKey>[] = [
    {
      key: "roles",
      title: "Role",
      options: roleOptions,
      className: "space-y-3",
    },
    {
      key: "customers",
      title: "Customer",
      options: customerOptions,
      columnKey: "customerId",
      className: "space-y-3 max-sm:my-4",
    },
    {
      key: "brands",
      title: "Brand",
      options: brandOptions,
      columnKey: "brandId",
      className: "space-y-3 max-md:mt-4",
    },
  ];

  return (
    <GenericFilter<T, PermissionFilterKey>
      setColumnFilter={setColumnFilter}
      filters={filters}
      filterConfigs={filterConfigs}
      title="Filter Permissions"
      minWidth="min-w-[600px]"
      gridCols="grid-cols-3"
    />
  );
};
